module.exports = __webpack_public_path__ + "static/media/Dr.-Indrajit-Prasad.ba637269.png";